/**
 * Skin registry — configuraciones visuales desacopladas.
 *
 * Cada skin declara:
 *  - id: identificador único (usado en data-skin del <html>).
 *  - label: nombre visible en /empresa cuando exista el selector.
 *  - fontsHref: URL de Google Fonts a inyectar (opcional).
 *  - bodyFontClass: clase Tailwind global aplicada al <body> (opcional).
 *
 * Los valores concretos de colores/tipografía viven en `skin.css` bajo el
 * selector [data-skin="<id>"]. Este archivo solo documenta la API pública.
 */

export const AVAILABLE_SKINS = [
  {
    id: 'legacy',
    label: 'Legacy · Verde Herringbone',
    fontsHref: null, // Manrope/Playfair ya están en index.css
  },
  {
    id: 'warm-professional',
    label: 'Warm Professional · Beige + Fraunces',
    fontsHref: 'https://fonts.googleapis.com/css2?family=Fraunces:wght@600;700&family=Inter:wght@400;500;600;700&display=swap',
  },
];

export const DEFAULT_SKIN_ID = 'warm-professional';

export const isValidSkin = (id) => AVAILABLE_SKINS.some((s) => s.id === id);
